import * as React from "react";

function FiatDepositNoBackground() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="20 55 260 260"
      width="34"
      height="34">
      <defs>
        <style>
          {
            ".cls-1,.cls-2{fill:none;stroke:#fff;strokeLinecap:round;strokeWidth:10px}.cls-1{stroke-miterlimit:100}.cls-2{strokeLinejoin:round}"
          }
        </style>
      </defs>
      <path
        className="cls-1"
        d="M177.78 95h79.11A18.24 18.24 0 01275 113.36v128.28A18.24 18.24 0 01256.89 260H43.11A18.24 18.24 0 0125 241.64V113.36A18.24 18.24 0 0143.11 95h79.11"
      />
      <path className="cls-2" d="M150 40L150 180" />
      <path className="cls-2" d="M118 150L150 180 182 150" />
      <rect className="cls-1" x={59.18} y={176.98} width={25.21} height={25.21} rx={0.92} />
      <path className="cls-1" d="M59.18 230.23L84.39 230.23" />
      <path className="cls-1" d="M104.23 230.23L129.44 230.23" />
      <path className="cls-1" d="M149.28 230.23L174.49 230.23" />
      <path className="cls-1" d="M194.32 230.23L219.53 230.23" />
    </svg>
  );
}

export default FiatDepositNoBackground;
